'use client';

/**
 * @packageDocumentation
 * @category Component
 */

import 'BomdisoftComponents/progress/styles.css';
import { getLanguageFromLocale, loadingT } from '@bomdisoft/translations';
import { useParams } from 'next/navigation';

export type ProgressIndicatorProps = {
  isOpen: boolean;
};

export const ProgressIndicator = ({ isOpen }: ProgressIndicatorProps) => {
  const params = useParams();
  const language = getLanguageFromLocale(typeof params?.lang === 'string' ? params.lang : undefined);
  return (
    <div className='bomdisoft-progress-backdrop' data-open={isOpen ? '' : undefined}>
      <div aria-label={loadingT[language]} className='bomdisoft-progress-bar' role='progressbar' />
    </div>
  );
};
